import type { QueryKey } from "@tanstack/react-query";

export const USER_KEY: QueryKey = ["user"];
export const AUTH_PROVIDERS_KEY: QueryKey = ["auth", "providers"];

export const LANGUAGES_KEY: QueryKey = ["translation", "languages"];

export const RESUME_KEY: QueryKey = ["resume"];
export const RESUMES_KEY: QueryKey = ["resumes"];
export const RESUME_PREVIEW_KEY: QueryKey = ["resume", "preview"];

export const ADMIN_USERS_KEY: QueryKey = ["admin", "users"];
export const ADMIN_STATS_KEY: QueryKey = ["admin", "stats"];

export const DOCUMENTS_KEY: QueryKey = ["documents"];
